export default __webpack_public_path__ + "static/media/ic-milking-shed.fb3f6fd7.svg";